import Cookies from "js-cookie"

// eslint-disable-next-line banhammer/no-restricted-functions
export const isSignedIn = () => `${Cookies.get("signed_in")}` === "1"

export const isSignedOut = () => !isSignedIn()
